import Figure, { FigureProps } from "./Figure"
import FigureContent from "./FigureContent"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

export type CurrentUnit = "kg" | "kW"
export type SecondaryUnit = "bar" | "kW"
export interface CurrentProps extends FigureProps {
  current?: number
  unit?: CurrentUnit
  secondary?: number
  secondaryUnit?: SecondaryUnit
}

const Current = ({ current, unit = "kg", secondary, secondaryUnit = "bar", compact = isCompactFigure("summary"), ...rest }: CurrentProps) => {
  const secondaryLabel = secondary ? `at ${Math.floor(secondary * 100) / 100} ${secondaryUnit}` : undefined
  return (
    <Figure compact={compact} {...rest}>
      <FigureContent.Root compact={compact}>
        <FigureContent.SubText compact={compact} link={secondaryLabel ? <FigureContent.Label>{secondaryLabel}</FigureContent.Label> : undefined}>current</FigureContent.SubText>
        <FigureContent.Value compact={compact}>
          {current !== undefined ? `${Math.floor(current * 100) / 100} ${unit}` : "0 kg"}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default Current
